const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20portrait%20of%20a%20young%20Chinese%20woman%20with%20warm%20smile%2C%20clean%20studio%20background%2C%20soft%20lighting%2C%20natural%20look%2C%20headshot%20style&width=120&height=120&seq=avatar-01&orientation=squarish',
    name: '小雨',
    role: '追剧达人',
    text: '桔子视频真的太方便了！以前要在好几个平台来回找资源，现在一个站就能看到红桃、樱桃、茄子、糖心的全部内容，再也不用反复切换了。',
    rating: 5,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20portrait%20of%20a%20young%20Chinese%20man%20with%20friendly%20expression%2C%20clean%20studio%20background%2C%20soft%20lighting%2C%20natural%20look%2C%20headshot%20style&width=120&height=120&seq=avatar-02&orientation=squarish',
    name: '大明',
    role: '影视爱好者',
    text: '更新速度是真的快，每天都有新内容。播放也很流畅不缓冲，体验比直接去原站还好。现在每天必刷桔子视频看看有什么新剧。',
    rating: 5,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20portrait%20of%20a%20young%20Chinese%20woman%20with%20gentle%20smile%2C%20clean%20studio%20background%2C%20soft%20lighting%2C%20natural%20look%2C%20headshot%20style&width=120&height=120&seq=avatar-03&orientation=squarish',
    name: '小美',
    role: '综艺粉',
    text: '糖心视频和茄子视频的综艺资源这里全都有，每周更新都能第一时间看到，太省心了。而且手机上看也很流畅，上下班路上追综艺超爽。',
    rating: 5,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20portrait%20of%20a%20young%20Chinese%20man%20with%20confident%20look%2C%20clean%20studio%20background%2C%20soft%20lighting%2C%20natural%20look%2C%20headshot%20style&width=120&height=120&seq=avatar-04&orientation=squarish',
    name: '阿杰',
    role: '短剧迷',
    text: '热门短剧分类特别全，比单一平台的内容丰富多了。桔子视频把各大平台的热门内容整合在一起，找片效率直接拉满，强烈推荐！',
    rating: 5,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-900 mb-3">
            观众热评
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            听听广大用户对桔子视频的真实评价
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {comments.map((item, i) => (
            <div
              key={i}
              className="p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.role}</div>
                </div>
              </div>
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: item.rating }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-xs text-secondary-500"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}